import { render, staticRenderFns } from "./mxactivityriskorders.vue?vue&type=template&id=17478fc6&"
import script from "./mxactivityriskorders.vue?vue&type=script&lang=js&"
export * from "./mxactivityriskorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports